import { colorPickerSlice } from "./slice";

export const { setSource, setImage, setSelectedColor, setCurrentColor, setIsImageLoading, setUploadData } =
    colorPickerSlice.actions;
